module.exports = __webpack_public_path__ + "img/toggle-off-circle.e2235a4c.svg";